import { useEffect } from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';
import isMobile from 'ismobilejs';

const mobile = isMobile(window.navigator).phone;

const useBuyMeACoffee = (config = {}) => {
    useEffect(() => {
        const {
            id = 'commandersalt.com',
            description = 'Support me on Buy me a coffee!',
            message = mobile ? '' : 'Coffee keeps the salt flowing!',
            color = '#5F7FFF',
            position = 'Right',
            xMargin = '18',
            yMargin = '10',
        } = config;

        console.log('Buy Me a Coffee: Initializing widget...');

        // Check if script already exists
        const existingScript = document.querySelector('script[data-name="BMC-Widget"]');
        if (existingScript) {
            console.log('Buy Me a Coffee: Widget already exists, skipping');
            return;
        }

        // Create and configure the script element with data attributes BEFORE setting src
        const script = document.createElement('script');
        script.setAttribute('data-name', 'BMC-Widget');
        script.setAttribute('data-cfasync', 'false');
        script.setAttribute('data-id', id);
        script.setAttribute('data-description', description);
        script.setAttribute('data-message', message);
        script.setAttribute('data-color', color);
        script.setAttribute('data-position', position);
        script.setAttribute('data-x_margin', xMargin);
        script.setAttribute('data-y_margin', yMargin);
        script.type = 'text/javascript';

        script.onload = () => {
            // Trigger DOMContentLoaded event manually to initialize the widget
            const event = new Event('DOMContentLoaded', {
                bubbles: true,
                cancelable: true,
            });
            document.dispatchEvent(event);

            setTimeout(() => {
                const widgetButton = document.querySelector('.bmc-btn') || document.getElementById('bmc-wbtn');
                if (!widgetButton) {
                    console.error('Buy Me a Coffee: Widget not initialized after DOMContentLoaded trigger');
                } else {
                    // Add click event listener for analytics tracking
                    widgetButton.addEventListener('click', () => {
                        try {
                            logEvent(getAnalytics(), 'buy_me_coffee_click');
                        } catch (error) {
                            console.error('Buy Me a Coffee: Failed to log analytics event', error);
                        }
                    });
                    console.log('Buy Me a Coffee: Click tracking enabled');
                }
            }, 1000);
        };

        script.onerror = (error) => {
            console.error('Buy Me a Coffee: Failed to load script', error);
        };

        // Set src AFTER all attributes are configured
        script.src = 'https://cdnjs.buymeacoffee.com/1.0.0/widget.prod.min.js';

        // Append to body
        document.body.appendChild(script);

        // Cleanup function
        return () => {
            const scriptToRemove = document.querySelector('script[data-name="BMC-Widget"]');
            const widgetElements = document.querySelectorAll('.bmc-btn, #bmc-wbtn, .bmc-modal');

            if (scriptToRemove) {
                scriptToRemove.remove();
            }

            widgetElements.forEach((el) => {
                el.remove();
            });
        };
    }, []);
};

export default useBuyMeACoffee;
